import axios from "axios"

const instance = axios.create({
  baseURL: "https://api.mytickle.io/api/",
  // timeout: 30000,
  withCredentials: true
});

// 401 처리 제외할 API
const AUTH_EXCLUDE_PATHS = [
  'users/login',
  'users/send-email',
  'users/auth-tempcode',
  'users/register',
  'users/register-child',
  'users/send-email/password-update',
  'users/update-password'
];

// 응답 인터셉터
// 세션 만료, 로그인하지 않은 경우 로그인 페이지로 이동
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url ?? '';

    const isAuthApi = AUTH_EXCLUDE_PATHS.some(path =>
      url.includes(path)
    );

    if (status === 401 && !isAuthApi) {
      window.location.replace('/login');
    }

    return Promise.reject(error);
  }
);
export default instance;